import { fromEvent } from "rxjs";
import { IMessagingService } from "../services";
import { IAnalyticsService } from "../services/interfaces/analyticsService";
import { Component } from "./component";
import { AnalyticsEventName } from "../enums/analyticsEventName";
import { LeftHandNavEvent } from "../models/analytics"

class SiteLeftMenuComponent extends Component {
    private analyticsService: IAnalyticsService;
    private componentEl: HTMLElement;

    constructor(componentEl: HTMLElement, messagingService: IMessagingService, analyticsService: IAnalyticsService) {
        super(componentEl, messagingService);

        this.analyticsService = analyticsService;
        this.componentEl = componentEl;
        this.initialize();
    }

    private initialize(): void {
        fromEvent<MouseEvent>(this.componentEl, 'click').subscribe(event => this.handleMenuClick(event));
    }

    private handleMenuClick(event: MouseEvent): void {
        const target = event.target as HTMLElement;
        const anchor = target.closest('a');

        if (!anchor || !anchor.hasAttribute('href')) return;

        const linkText = anchor.innerText?.trim();

        if (!linkText) return;

        const analyticsData = new LeftHandNavEvent(linkText);

        this.analyticsService.RecordEvent(AnalyticsEventName.LeftHandNavEvent, analyticsData);
    }
};

export { SiteLeftMenuComponent };
